import { render, staticRenderFns } from "./BoxActionInProfile.vue?vue&type=template&id=4a9a0d71&scoped=true"
import script from "./BoxActionInProfile.vue?vue&type=script&lang=js"
export * from "./BoxActionInProfile.vue?vue&type=script&lang=js"
import style0 from "./BoxActionInProfile.vue?vue&type=style&index=0&id=4a9a0d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a0d71",
  null
  
)

export default component.exports